<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<nz-table #sessionTable [nzTitle]="tableHead" [nzScroll]="{ y: '500px' }" class="mt-5" [nzData]="inputTableData!.data"
  nzFrontPagination="false" [nzTotal]="inputTableData!.totalRecords" [nzPageSize]="inputTableData!.pageSize"
  [nzBordered]="true" [nzShowSizeChanger]="true" [nzPageSizeOptions]="pageSizeOptions"
  [nzPageIndex]="inputTableData!.pageNum" nzTableLayout="fixed" (nzPageIndexChange)="nzPageIndexChange($event)"
  (nzPageSizeChange)="nzPageSizeChange($event)">
  <thead>
    <tr>
      <th nzCustomFilter>Client Details</th>
      <th nzCustomFilter>
        Partner Details
        <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="partnerIdMenu">
          <span nz-icon nzTheme="outline" nzType="filter"></span>
        </nz-filter-trigger>
      </th>
      <th (nzSortOrderChange)="sortSessionDates($event)" nzCustomFilter nzShowSort="true">
        Session Timing
        <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="sessionDateFilterMenu">
          <span nz-icon nzTheme="outline" nzType="schedule"></span>
        </nz-filter-trigger>
      </th>
      <th nzCustomFilter nzWidth="100px">
        Therapist Details
        <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="therapistFilterMenu">
          <span nz-icon nzTheme="outline" nzType="schedule"></span>
        </nz-filter-trigger>
      </th>
      <th nzCustomFilter>
        Session Status
        <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="sessionStatusMenu">
          <span nz-icon nzTheme="outline" nzType="filter"></span>
        </nz-filter-trigger>
      </th>
      <th *ngIf="selectedTab === 1" (nzSortOrderChange)="sortTherapistRating($event)" nzShowSort="true" nzWidth="100px">
        User Rating
      </th>
      <th nzWidth="23%">
        Session tags
        <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="sessionTagMenu">
          <span nz-icon nzTheme="outline" nzType="filter"></span>
        </nz-filter-trigger>
      </th>
      <th *ngIf="selectedTab === 0">No Of NoShow Sessions</th>

      <th *ngIf="selectedTab === 1" nzWidth="10%">Meet Participant</th>
      <th nzWidth="130px">Policy</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let data of sessionTable.data">
      <tr>
        <td (nzExpandChange)="onExpandChange(data.id, $event)" [nzExpand]="expandSet.has(data.id)">
          {{ data.clientDetails.name }}<br />
          <a nz-dropdown [nzDropdownMenu]="menu">
            <u class="cursor-pointer">{{ data.clientDetails.email }}</u>
          </a>
        </td>
        <td>
          {{ data.clientDetails.partnerId }}
          <br />
          {{ data.clientDetails.partnerName }}
          <br />
          <nz-tag *ngIf="data.clientDetails.partnerId === 'PR-9008'" nzColor="cyan">Retail User</nz-tag>
          <nz-tag *ngIf="data.clientDetails.partnerId !== 'PR-9008'" nzColor="cyan">Corporate User</nz-tag>
        </td>
        <td>
          <div *ngIf="data.appointmentRequestDate" nz-row nzJustify="start">
            Requested Date: {{ formatSessionDate(data.appointmentRequestDate) }}
          </div>
          <div nz-row nzJustify="start">
            Session Date: {{ formatSessionDate(data.sessionDate) }}
          </div>
          <div nz-row nzJustify="start">
            {{ formatSessionTime(data.sessionStart) }} -
            {{ formatSessionTime(data.sessionEnd) }}
          </div>
          <div nz-row nzJustify="start">
            <nz-tag *ngIf="data.offline" nzColor="red">Offline</nz-tag>
            <nz-tag *ngIf="!data.offline" nzColor="purple">Online</nz-tag>
            <div *ngIf="data.offline">
              {{ "Offline Address : " + data.offlineAddress }}
              {{ "Offline City : " + data.offlineCity }}
            </div>
          </div>
        </td>
        <td>
          <div>
            <a nz-dropdown [nzDropdownMenu]="therapistMenu">
              <u class="cursor-pointer">{{
                data.therapistDetails.therapistName
                }}</u>
            </a>
          </div>
        </td>
        <td>
          {{ data.sessionStatus }}
        </td>
        <td *ngIf="selectedTab === 1">
          {{ data.rating === 0 ? "N/A" : data.rating }}
        </td>
        <td>
          <div *ngIf="data.sessionTags" nz-row nzJustify="start">
            <div *ngFor="let tag of data.sessionTags" class="mb-1" nz-col>
              <nz-tag [nzColor]="'green'">{{ tag }}</nz-tag>
            </div>
          </div>
        </td>
        <td *ngIf="selectedTab === 0">
          <div *ngIf="data.noShowSessionsCount" class="cursor-pointer underline"
            (click)="openUserSessionPage(data.clientDetails.id)">
            {{ data.noShowSessionsCount }}
          </div>
          <div *ngIf="!data.noShowSessionsCount">N/A</div>
        </td>

        <td *ngIf="selectedTab === 1">
          <div *ngIf="!data.meetParticipantData">N/A</div>
          <div class="flex flex-col items-start gap-2" *ngIf="data.meetParticipantData">
            <p>
              Total Meeting Duration :
              {{ data.meetParticipantData.totalMeetingDurationFormatted }}
            </p>
            <p>
              Total Participants :
              {{ data.meetParticipantData.totalParticipants }}
            </p>
            <button *ngIf="data.meetParticipantData?.participants" nz-button (click)="
                openMeetParticipant(data.meetParticipantData.participants!)
              ">
              Participants
            </button>
          </div>
        </td>
        <!-- Policy Trace column -->
        <td>
          <ng-container *ngIf="data.policyTrace; else noPolicy">
            <button nz-button nzType="link" nzSize="small" class="p-0" (click)="openPolicyTrace(data)">
              <nz-tag [nzColor]="
                  data.policyTrace.outputs.sessionAllowed === true ||
                  data.policyTrace.outputs.sessionAllowed === 'true'
                    ? 'green'
                    : 'red'
                ">
                {{
                data.policyTrace.outputs.sessionAllowed === true ||
                data.policyTrace.outputs.sessionAllowed === 'true'
                ? 'Allowed'
                : 'Blocked'
                }}
              </nz-tag>
            </button>
            <div class="text-xs text-gray-400 mt-1">
              <span *ngIf="data.policyTrace.outputs.payer">
                {{ data.policyTrace.outputs.payer }}
              </span>
              <span *ngIf="data.policyTrace.outputs.sessionMinutes">
                · {{ data.policyTrace.outputs.sessionMinutes }} min
              </span>
              <span *ngIf="
                  data.policyTrace.outputs.blockReason &&
                  !(
                    data.policyTrace.outputs.sessionAllowed === true ||
                    data.policyTrace.outputs.sessionAllowed === 'true'
                  )
                " class="text-red-500">
                {{ data.policyTrace.outputs.blockReason }}
              </span>
            </div>
          </ng-container>
          <ng-template #noPolicy>
            <span class="text-gray-400">—</span>
          </ng-template>
        </td>

        <td>
          <div nz-row nzJustify="start">
            <div class="m-1" colspan="1" nz-col *ngIf="showConfirmButton(data.sessionStatus)">
              <span nz-tooltip nzTooltipTitle="Confirm Appointment">
                <button class="btn-color" (click)="confirmAppointmentFn(data.id)" nz-button nzShape="circle"
                  nzType="primary" [nzDanger]="
                    data.sessionStatus === SessionStatus.CANCELLATION_REQUESTED
                      ? true
                      : false
                  ">
                  <span nz-icon nzTheme="outline" [nzType]="
                      data.sessionStatus ===
                      SessionStatus.CANCELLATION_REQUESTED
                        ? 'close'
                        : 'check'
                    "></span>
                </button>
              </span>
            </div>
            <div class="m-1" colspan="1" nz-col *ngIf="showNewBookingBtn && hasCloudflareTag(data.sessionTags)">
              <span nz-tooltip nzTooltipTitle="Assign Google Meet">
                <button class="btn-color" (click)="assignGoogleMeetFn(data.id)" nz-button nzShape="circle"
                  nzType="primary">
                  <span nz-icon nzTheme="outline" nzType="video-camera"></span>
                </button>
              </span>
            </div>
            <div class="m-1" colspan="1" nz-col *ngIf="showCancelButton(data.sessionStatus)">
              <span nz-tooltip [nzTooltipTitle]="
                  data.sessionStatus === SessionStatus.CANCELLATION_REQUESTED
                    ? 'Cancellation Requested'
                    : 'Cancel Appoinment'
                ">
                <button class="btn-color" (click)="
                    cancelAppointmentFn(
                      data.id,
                      data.clientDetails.name,
                      data.clientDetails.email
                    )
                  " nz-button [nzDanger]="
                    data.sessionStatus === SessionStatus.CANCELLATION_REQUESTED
                      ? false
                      : true
                  " nzShape="circle" nzType="primary">
                  <span nz-icon nzTheme="outline" [nzType]="
                      data.sessionStatus ===
                      SessionStatus.CANCELLATION_REQUESTED
                        ? 'check'
                        : 'close'
                    "></span>
                </button>
              </span>
            </div>
            <div class="m-1" colspan="1" nz-col *ngIf="
                showUpdateButton(data.sessionStatus) && showUpdateButtonPortal
              ">
              <span nz-tooltip nzTooltipTitle="Update Appoinments">
                <button class="btn-color" (click)="UpdateAppointmentFn(data)" nz-button nzShape="circle"
                  nzType="primary">
                  <span nz-icon nzType="database" nzTheme="outline"></span>
                </button>
              </span>
            </div>
            <div class="m-1" colspan="1" nz-col *ngIf="
                showFeedbackPendingButton(data.sessionStatus, data.sessionEnd)
              ">
              <span nz-tooltip nzTooltipTitle="Feedback Pending">
                <button class="btn-color" (click)="showFeedBackFormFn(data)" nz-button nzShape="circle"
                  nzType="primary">
                  <span *ngIf="!showBarIcon" nz-icon nzTheme="outline" nzType="profile"></span>
                  <span *ngIf="showBarIcon" nz-icon nzType="bars" nzTheme="outline"></span>
                </button>
              </span>
            </div>
            <div class="m-1" colspan="1" nz-col *ngIf="showRemarkButton(data.sessionStatus, data.sessionEnd)">
              <span nz-tooltip nzTooltipTitle="Add Remarks">
                <button class="btn-color" (click)="openRemarkForm(data)" nz-button nzShape="circle" nzType="primary">
                  <span nz-icon nzType="comment" nzTheme="outline"></span>
                </button>
              </span>
            </div>
            <div class="m-1" *ngIf="data.remarks" colspan="1" nz-col>
              <span nz-tooltip nzTooltipTitle="Remarks">
                <button nz-button class="btn-color" nzType="primary" nzShape="circle"
                  (click)="showRemarksModalFn(data)">
                  <span nz-icon *ngIf="!showBarIcon" nzType="info" nzTheme="outline"></span>
                  <span nz-icon *ngIf="showBarIcon" nzType="info-circle" nzTheme="outline"></span>
                </button>
              </span>
            </div>
            <div class="m-1" colspan="1" nz-col *ngIf="showAddLedgerAmountButton(data.sessionStatus)">
              <span nz-tooltip nzTooltipTitle="Add ledger amount">
                <button class="btn-color" (click)="openAddRewardModal(data.id)" nz-button nzShape="circle"
                  nzType="primary">
                  <span nz-icon nzType="dollar" nzTheme="outline"></span>
                </button>
              </span>
            </div>
            <div class="m-1" colspan="1" nz-col *ngIf="showRescheduleDeclineButton(data.sessionStatus)">
              <span nz-tooltip nzTooltipTitle="Reschedule declined">
                <button class="btn-color" (click)="appointmentRescheduleDeclineRequestFn(data)" nz-button
                  nzShape="circle" nzType="primary" [nzDanger]="true">
                  <span nz-icon nzType="issues-close" nzTheme="outline"></span>
                </button>
              </span>
            </div>
            <div class="m-1" colspan="1" nz-col *ngIf="
                canShowOverrideButton && canOverrideSession(data.sessionStatus)
              ">
              <span nz-tooltip nzTooltipTitle="Override Session Status">
                <button class="btn-color" (click)="openOverrideModal(data)" nz-button nzShape="circle" nzType="default"
                  [nzDanger]="true">
                  <span nz-icon nzType="tool" nzTheme="outline"></span>
                </button>
              </span>
            </div>
            <div class="m-1" colspan="1" nz-col>
              <span nz-tooltip nzTooltipTitle="Sync Meet Participant Data">
                <button class="btn-color" (click)="syncMeetParticipantData(data.id)" nz-button nzShape="circle"
                  nzType="primary">
                  <span nz-icon nzType="sync" nzTheme="outline"></span>
                </button>
              </span>
            </div>
          </div>
        </td>
      </tr>
      <tr [nzExpand]="expandSet.has(data.id)">
        <div nz-row nzAlign="top" nzJustify="start">
          <div class="ml-1 mr-1 w-[20%]" colspan="2" nz-col>
            {{ data.id }}
            <br />
            Gender: {{ data.clientDetails.gender }} <br />Phone:
            {{ data.clientDetails.phone }}<br />
            PartnerId: {{ data.clientDetails.partnerId }}
            <br />
            PartnerName: {{ data.clientDetails.partnerName }}
          </div>
          <div class="ml-1 mr-1 w-[20%]" colspan="2" nz-col>
            <div *ngIf="data.appointmentConfirmedDate" nz-row nzJustify="start">
              Confirmed Date:
              {{ formatSessionDate(data.appointmentConfirmedDate) }}
            </div>
            <div *ngIf="data.appointmentConfirmedBy" nz-row nzJustify="start">
              Confirmed By: {{ data.appointmentConfirmedBy }}
            </div>
            <div *ngIf="data.appointmentCancellationDate" nz-row nzJustify="start">
              Cancelled Date:
              {{ formatSessionDate(data.appointmentCancellationDate) }}
            </div>
            <div *ngIf="data.appointmentCancelledBy" nz-row nzJustify="start">
              Cancelled By: {{ data.appointmentCancelledBy }}
            </div>
            <div *ngIf="showUpdateButtonPortal && data.userRescheduleReason" nz-row nzJustify="start">
              User Reschedule Reason: {{ data.userRescheduleReason }}
            </div>
            <div *ngIf="showUpdateButtonPortal && data.expertRescheduleReason" nz-row nzJustify="start">
              Expert Reschedule Reason: {{ data.expertRescheduleReason }}
            </div>
          </div>
          <div class="ml-1 mr-1 w-[20%]" colspan="2" nz-col>
            <br />
            {{ data.therapistDetails.therapistEmail }}
            <br />
            {{ data.therapistDetails.therapistPhone }}
            <br />
            {{ data.callLink }}
            <span *ngIf="data.callProvider" class="text-gray-500">({{ data.callProvider }})</span>
          </div>
          <div *ngIf="data.planSubcriptionId" class="ml-1 mr-1 w-[20%]" colspan="2" nz-col>
            Plan Subcription Id : {{ data.planSubscriptionDetails?.id }}
            <br />
            Plan Name:
            <u (click)="
                openTherapyPlansSubscriptionPageByPlanName(
                  data.planSubscriptionDetails?.planId!
                )
              " class="cursor-pointer">
              {{ data.planSubscriptionDetails?.planName }} </u><br />Purchased Date :
            {{
            utils.convertEpochToFormattedDate(
            data.planSubscriptionDetails?.purchasedAt!
            )
            }}
            <br />
            Validity:
            {{
            utils.convertEpochToFormattedDate(
            data.planSubscriptionDetails?.validTill!
            )
            }}
            <br />
            Payment Type:
            {{
            utils.convertToTitleCase(
            data.planSubscriptionDetails?.paymentType!
            )
            }}
            <br />
            Verticle : {{ data.planSubscriptionDetails?.vertical }}
            <br />
            Concern : {{ data.planSubscriptionDetails?.concern }}
            <br />
            No of Session:
            {{
            data.planSubscriptionDetails?.completedSessions +
            "/" +
            data.planSubscriptionDetails?.noOfSessions
            }}
          </div>
          <div class="w-[20%]" colspan="1" nz-col>
            <h1>Testimonial :</h1>
            <br />
            {{ data.testimonial }}
          </div>
          <div class="w-[20%]" colspan="1" nz-col>
            {{ data.meetParticipantData?.participants }}
          </div>
        </div>
      </tr>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu nzSelectable>
          <li (click)="openUserSessionPage(data.clientDetails.id)" nz-menu-item>
            Go to Session Filter by UserId
          </li>
          <li *ngIf="data.sessionTags.includes(SessionTags.SESSION_PLANS)" (click)="
              openTherapyPlansSubscriptionPageByUser(data.clientDetails.id)
            " nz-menu-item>
            Go to Therapy Plan Subscription
          </li>
          <li *ngIf="data.sessionTags.includes(SessionTags.SESSION_PACKS)" (click)="
              openTherapyPacksSubscriptionPageByUser(data.clientDetails.id)
            " nz-menu-item>
            Go to Therapy Packs Subscription
          </li>
        </ul>
      </nz-dropdown-menu>
      <nz-dropdown-menu #therapistMenu="nzDropdownMenu">
        <ul nz-menu nzSelectable>
          <li (click)="openTherapistSessionsPage(data.therapistDetails.id)" nz-menu-item>
            Filtered Session For this therapist
          </li>
          <li (click)="openClients(data.therapistDetails.userId)" nz-menu-item>
            View Clients
          </li>
        </ul>
      </nz-dropdown-menu>
    </ng-container>
  </tbody>
</nz-table>
<nz-dropdown-menu #sessionStatusMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <span class="font-bold">Session Status</span>
    </div>
    <div nz-row>
      <div nz-col>
        <nz-checkbox-wrapper (nzOnChange)="sessionStatusFilterChangeFn($event)">
          <div *ngFor="let sessionStatus of sessionStatusCheckBoxOptions" nz-row>
            <div nz-col>
              <label nz-checkbox [nzValue]="sessionStatus.value" [ngModel]="sessionStatus.checked">{{
                sessionStatus.label }}</label>
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col class="mr-1">
        <button class="m-1" nz-button nzType="primary" class="btn-color" (click)="sessionStatusFilterFn()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" class="btn-color" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<!-- <nz-dropdown-menu #partnerIdMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <span class="font-bold">Partner Id</span>
    </div>
    <div nz-row>
      <div nz-col>
        <nz-checkbox-wrapper (nzOnChange)="partnerIdFilterChangeFn($event)">
          <div *ngFor="let partnerId of partnerIdCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                [ngModel]="partnerId.checked"
                [nzValue]="partnerId.value"
                nz-checkbox
                >{{ partnerId.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col class="mr-1">
        <button
          (click)="partnerIdFilterFn()"
          class="btn-color"
          class="m-1"
          nz-button
          nzType="primary"
        >
          Ok
        </button>
      </div>

      <div nz-col>
        <button
          (click)="resetFilter()"
          class="btn-color"
          class="m-1"
          nz-button
          nzType="primary"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu> -->
<nz-dropdown-menu #therapistFilterMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <span class="font-bold">Therapists</span>
    </div>
    <div nz-row>
      <div nz-col class="h-96 overflow-y-scroll py-2">
        <nz-checkbox-wrapper (nzOnChange)="therapistFilterChangeFn($event)">
          <div *ngFor="let therapist of therapistCheckBoxOptions" nz-row>
            <div nz-col [style.background-color]="
                !therapist.data.isAvailable ? '#e0e0e0' : ''
              " class="mt-2 rounded-lg px-1">
              <label nz-checkbox [nzValue]="therapist.value" [ngModel]="therapist.checked">{{ therapist.label }}</label>
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col class="mr-1">
        <button class="m-1" nz-button nzType="primary" class="btn-color" (click)="therapistFilterFn()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" class="btn-color" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #sessionDateFilterMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="ng-row">
      <nz-range-picker [(ngModel)]="sessionColumnFilterDate"
        (ngModelChange)="onSessionFilterDateChange($event)"></nz-range-picker>
    </div>
    <div nz-row class="mt-5" nzJustify="end">
      <div nz-col class="mr-1">
        <button class="m-1" nz-button nzType="primary" class="btn-color" (click)="dateFilterFn()">
          Ok
        </button>
      </div>
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" class="btn-color" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<ng-template #tableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="font-bold">Sessions</span>
    </div>
    <div nz-col>
      <div nz-row nzAlign="middle">
        <div nz-col>
          <nz-switch (ngModelChange)="testBookingChangeFn()" [(ngModel)]="showTestBookings"
            nzCheckedChildren="Hide Test Bookings" nzUnCheckedChildren="Show Test Bookings"></nz-switch>
        </div>
        <div nz-col>
          <div *ngIf="showNewBookingBtn" class="m-1" nz-col>
            <button class="btn-color pr-1" (click)="showNewSessionFn()" nz-button nzSize="small" nzType="primary">
              <span nz-icon nzTheme="outline" nzType="plus"></span>
              New Booking Plans
            </button>
          </div>
        </div>
        <div nz-col>
          <div *ngIf="showNewBookingBtn" class="m-1" nz-col>
            <button class="btn-color pr-1" (click)="showNewSessionPackFn()" nz-button nzSize="small" nzType="primary">
              <span nz-icon nzTheme="outline" nzType="plus"></span>
              New Booking Packs
            </button>
          </div>
        </div>
        <div nz-col>
          <div *ngIf="showNewBookingBtn" class="m-1" nz-col>
            <button class="btn-color pr-1" (click)="showActivateNewPlaModal()" nz-button nzSize="small"
              nzType="primary">
              <span nz-icon nzTheme="outline" nzType="plus"></span>
              Activate New Plan
            </button>
          </div>
        </div>
        <div nz-col class="m-1">
          <button class="btn-color" (click)="exportData()" nz-button nzSize="small" nzType="primary">
            <span nz-icon nzType="download"></span>
            Export
          </button>
        </div>
        <div nz-col class="m-1">
          <button class="btn-color" nz-button nzSize="small" nzType="primary" (click)="resetFilter()">
            Clear filter
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<nz-modal [(nzVisible)]="showRemarksModal" (nzOnCancel)="closeRewardsModal()" (nzOnOk)="closeRewardsModal()"
  nzWidth="700px">
  <ng-container *nzModalContent>
    <nz-table #remarksTable [nzData]="selectedSession!.remarks!">
      <thead>
        <tr>
          <th>
            {{ getColumnName() }}
          </th>
          <th>Date</th>
          <th nzWidth="50%">Remarks</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let remark of remarksTable.data">
          <td>
            {{ remark.addedBy }}
          </td>
          <td>
            {{ formatSessionDate(remark.addedAt) }}
          </td>
          <td>
            {{ remark.remark }}
          </td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>
</nz-modal>
<nz-modal [nzOkLoading]="feedbackFormSubmitLoading" [(nzVisible)]="showFeedBackForm"
  nzTitle="Therapist Session Feedback" (nzOnCancel)="closeFeedbackForm()" (nzOnOk)="submitFeedBack()">
  <ng-container *nzModalContent>
    <div nz-row>Session Completed ?</div>
    <div nz-row class="mt-1">
      <nz-radio-group [(ngModel)]="sessionCompleted" (ngModelChange)="sessionCompletedChangeFn($event)">
        <label nz-radio nzValue="Yes">Yes</label>
        <label nz-radio nzValue="No">No</label>
      </nz-radio-group>
    </div>
    <div nz-row class="mt-1">Session Status</div>
    <div nz-row class="mt-1">
      <nz-select class="w-[50%]" *ngIf="isSessionCompleted()" nzShowSearch nzAllowClear nzPlaceHolder="Select Status"
        [(ngModel)]="selectedStatus">
        <nz-option nzLabel="Completed" nzValue="Completed"></nz-option>
      </nz-select>
      <nz-select class="w-[50%]" *ngIf="!isSessionCompleted()" nzShowSearch nzAllowClear nzPlaceHolder="Select Status"
        [(ngModel)]="selectedStatus">
        <nz-option nzLabel="No Show Therapist" nzValue="No Show Therapist"></nz-option>
        <nz-option nzLabel="No Show User" nzValue="No Show User"></nz-option>
        <nz-option nzLabel="Tech Issue" nzValue="Tech Issue"></nz-option>
        <nz-option nzLabel="Missed Appointment" nzValue="Missed Appointment"></nz-option>
      </nz-select>
    </div>
    <div nz-row class="mt-2">
      <textarea rows="4" nz-input placeholder="Remarks" [(ngModel)]="feedbackRemarks"></textarea>
    </div>
  </ng-container>
</nz-modal>
<nz-modal [nzOkDisabled]="sessionOkDisabled" nzOkText="Book Session" (nzOnCancel)="closeNewSessionModal()"
  (nzOnOk)="submitNewSessionFn()" [(nzVisible)]="showNewSessionModal" [nzOkLoading]="newSessionSubmitProgress"
  nzTitle="New Session For Plans">
  <ng-container *nzModalContent>
    <!-- Search User -->
    <div nz-row class="mb-4" nzAlign="middle">
      <div nz-col [nzSpan]="24">
        <label class="font-medium mb-1 block">Search User</label>
        <div class="flex items-center">
          <input class="w-full" placeholder="Search Users" nz-input [(ngModel)]="selectedUser"
            (input)="onSearchUser($event)" [nzAutocomplete]="auto"
            (ngModelChange)="onUserSelectedBookNewSession($event)" />
          <nz-autocomplete [nzDataSource]="userSearchResults" nzBackfill #auto></nz-autocomplete>
          <nz-spin nzSimple [nzSpinning]="searchSpinner" [nzSize]="'small'" class="ml-2"></nz-spin>
        </div>
      </div>
    </div>

    <!-- Select Plan -->
    <div nz-row class="mb-4">
      <div nz-col [nzSpan]="24">
        <label class="font-medium mb-1 block">Select Plan</label>
        <nz-select class="w-full" placeholder="Select Plan" nzShowSearch nzAllowClear [(ngModel)]="selectedActivePlanId"
          (ngModelChange)="onActivePlanSelected($event)">
          <nz-option *ngFor="let plan of userActivePlans" [nzLabel]="
              plan.planName +
              ' - ' +
              plan.therapyVertical +
              ' - ' +
              plan.therapistDetails.therapistName
            " [nzValue]="plan.id"></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Select Session Date -->
    <div nz-row class="mb-4">
      <div nz-col [nzSpan]="24">
        <label class="font-medium mb-1 block">Select Date</label>
        <nz-spin [nzSize]="'small'" [nzSpinning]="bookSessionDateTimeSpinner">
          <nz-date-picker class="w-full" (ngModelChange)="onNewSessionDateChange($event)"
            [(ngModel)]="date"></nz-date-picker>
        </nz-spin>
      </div>
    </div>

    <!-- Select Session Duration -->
    <div nz-row class="mb-4" *ngIf="check60MinIsAvailable() && !isIntroSession">
      <div nz-col [nzSpan]="24">
        <label class="font-medium mb-1 block">Select Session Duration</label>
        <nz-select class="w-full" placeholder="Select Duration" [(ngModel)]="selectedDuration"
          (ngModelChange)="onDurationSelected($event)">
          <nz-option [nzValue]="30" nzLabel="30 minutes"></nz-option>
          <nz-option [nzValue]="50" nzLabel="50 minutes"></nz-option>
        </nz-select>
      </div>
    </div>

    <div nz-row class="mb-4">
      <div nz-col [nzSpan]="24">
        <label class="font-medium mb-1 block">Online/Offline</label>
        <nz-switch [(ngModel)]="onlinePlans" nzCheckedChildren="Enabled Online"
          nzUnCheckedChildren="Enabled Offline"></nz-switch>
      </div>
    </div>

    <!-- Time Slots -->
    <div nz-row class="mb-4" nzAlign="middle">
      <div nz-col [nzSpan]="24">
        <label *ngIf="checkBoxTimeRangeOptions.length > 0" class="font-medium mb-2 block">Available Slots</label>
        <div *ngIf="checkBoxTimeRangeOptions.length > 0">
          <nz-checkbox-wrapper (nzOnChange)="onNewSessionTimeChange($event)">
            <div *ngFor="let status of checkBoxTimeRangeOptions; let i = index" class="mb-1">
              <label nz-checkbox [nzDisabled]="status.disabled" [nzValue]="status.value" [(ngModel)]="status.checked"
                (ngModelChange)="onCheckboxClick($event, i)">
                {{ status.label }}
                <span *ngIf="status.isOverlapUnavailable"
                  style="color: #ff4d4f; margin-left: 8px; font-size: 12px; font-weight: 500;">(Overlap)</span>
                <span *ngIf="!status.value.available || status.value.notAvailableSlotExists"
                  style="color: #8c8c8c; margin-left: 8px; font-size: 12px;">(Unavailable)</span>
              </label>
            </div>
          </nz-checkbox-wrapper>
        </div>
        <div *ngIf="checkBoxTimeRangeOptions.length <= 0">
          No Available Slots
        </div>
      </div>
    </div>

    <!-- Optional Emergency Booking (commented) -->
    <!--
    <div nz-row class="mt-2">
      <label nz-checkbox [(ngModel)]="emergencyBooking">
        Emergency Booking
      </label>
    </div>
    -->
  </ng-container>
</nz-modal>
<nz-modal [nzOkDisabled]="sessionOkDisabled" nzOkText="Book Session" (nzOnCancel)="closeNewSessionPackModal()"
  (nzOnOk)="submitNewPackSessionFn()" [(nzVisible)]="showNewSessionPacksModal" [nzOkLoading]="newSessionSubmitProgress"
  nzTitle="New Session For Packs">
  <ng-container *nzModalContent>
    <!-- Search User -->
    <div nz-row class="mb-4" nzAlign="middle">
      <div nz-col [nzSpan]="24">
        <label class="font-medium mb-1 block">Search User</label>
        <div class="flex items-center">
          <input class="w-full" placeholder="Search Users" nz-input [(ngModel)]="selectedUser"
            (input)="onSearchUser($event)" [nzAutocomplete]="auto"
            (ngModelChange)="onUserSelectedBookNewSession($event)" />
          <nz-autocomplete [nzDataSource]="userSearchResults" nzBackfill #auto></nz-autocomplete>
          <nz-spin nzSimple [nzSpinning]="searchSpinner" [nzSize]="'small'" class="ml-2"></nz-spin>
        </div>
      </div>
    </div>

    <!-- Select Plan -->
    <div nz-row class="mb-4">
      <div nz-col [nzSpan]="24">
        <label class="font-medium mb-1 block">Select Packs</label>
        <nz-select class="w-full" placeholder="Select Packs" nzShowSearch nzAllowClear
          [(ngModel)]="selectedActivePackId" (ngModelChange)="onActivePackSelected($event)">
          <nz-option *ngFor="let pack of userActivePacks" [nzLabel]="pack.packMeta.name"
            [nzValue]="pack.id"></nz-option>
        </nz-select>
      </div>
    </div>
    <div nz-row class="mb-4">
      <div nz-col [nzSpan]="24">
        <label class="font-medium mb-1 block">Select Therapist From Packs</label>
        <nz-select class="w-full" placeholder="Select Packs From Packs" nzShowSearch nzAllowClear
          [(ngModel)]="selectedTherapist" (ngModelChange)="onSelectTherapistForPacks($event)">
          <nz-option *ngFor="let pack of selectOptionsPacks" [nzLabel]="pack.label" [nzValue]="pack.value"></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Select Session Date -->
    <div nz-row class="mb-4">
      <div nz-col [nzSpan]="24">
        <label class="font-medium mb-1 block">Select Date</label>
        <nz-spin [nzSize]="'small'" [nzSpinning]="bookSessionDateTimeSpinner">
          <nz-date-picker class="w-full" (ngModelChange)="onNewSessionDateChange($event)"
            [(ngModel)]="date"></nz-date-picker>
        </nz-spin>
      </div>
    </div>

    <!-- Select Session Duration -->
    <div nz-row class="mb-4" *ngIf="check60MinIsAvailableForPacks()">
      <div nz-col [nzSpan]="24">
        <label class="font-medium mb-1 block">Select Session Duration</label>
        <nz-select class="w-full" placeholder="Select Duration" [(ngModel)]="selectedDuration"
          (ngModelChange)="onDurationSelected($event)">
          <nz-option [nzValue]="30" nzLabel="30 minutes"></nz-option>
          <nz-option [nzValue]="50" nzLabel="50 minutes"></nz-option>
        </nz-select>
      </div>
    </div>

    <div nz-row class="mb-4">
      <div nz-col [nzSpan]="24">
        <label class="font-medium mb-1 block">Online/Offline</label>
        <nz-switch [(ngModel)]="onlinePacks" nzCheckedChildren="Enabled Online"
          nzUnCheckedChildren="Enabled Offline"></nz-switch>
      </div>
    </div>

    <!-- Time Slots -->
    <div nz-row class="mb-4" nzAlign="middle">
      <div nz-col [nzSpan]="24">
        <label *ngIf="checkBoxTimeRangeOptions.length > 0" class="font-medium mb-2 block">Available Slots</label>
        <div *ngIf="checkBoxTimeRangeOptions.length > 0">
          <nz-checkbox-wrapper (nzOnChange)="onNewSessionTimeChange($event)">
            <div *ngFor="let status of checkBoxTimeRangeOptions; let i = index" class="mb-1">
              <label nz-checkbox [nzDisabled]="status.disabled" [nzValue]="status.value" [(ngModel)]="status.checked"
                (ngModelChange)="onCheckboxClick($event, i)">
                {{ status.label }}
                <span *ngIf="status.isOverlapUnavailable"
                  style="color: #ff4d4f; margin-left: 8px; font-size: 12px; font-weight: 500;">(Overlap)</span>
                <span *ngIf="!status.value.available || status.value.notAvailableSlotExists"
                  style="color: #8c8c8c; margin-left: 8px; font-size: 12px;">(Unavailable)</span>
              </label>
            </div>
          </nz-checkbox-wrapper>
        </div>
        <div *ngIf="checkBoxTimeRangeOptions.length <= 0">
          No Available Slots
        </div>
      </div>
    </div>

    <!-- Optional Emergency Booking (commented) -->
    <!--
    <div nz-row class="mt-2">
      <label nz-checkbox [(ngModel)]="emergencyBooking">
        Emergency Booking
      </label>
    </div>
    -->
  </ng-container>
</nz-modal>
<nz-modal [(nzVisible)]="visibleUpdateAppointment" nzTitle="Update Appointment" (nzOnCancel)="closeUpdateModal()"
  (nzOnOk)="submitUpdateAppointment()" [nzOkLoading]="updateAppointmentSubmitLoading">
  <ng-container *nzModalContent>
    <div nz-row nzAlign="middle">
      <div nz-col colspan="2">
        <label class="feedback-yes">Therapist Name</label>
        <div>
          <nz-select class="w-[250px] mr-2" nzShowSearch nzAllowClear nzPlaceHolder="Select Therapist"
            [(ngModel)]="selectedTherapistString" (ngModelChange)="onUpdateTherapistChange($event)">
            <nz-option *ngFor="let th of therapistWithId" [nzLabel]="th.label" [nzValue]="th.value"></nz-option>
          </nz-select>
        </div>
      </div>
      <!-- <div nz-col colspan="2">
        <label class="feedback-yes">Time</label>
        <div>
          <nz-time-picker
            (ngModelChange)="onUpdateSessionTimeChange($event)"
            [(ngModel)]="startTime"
            nzFormat="HH:mm"
            nzPlaceHolder="Select time"
          ></nz-time-picker>
        </div>
      </div> -->
      <div nz-col colspan="2" class="pt-2">
        <label class="feedback-yes">Date</label>
        <div>
          <nz-date-picker class="w-[250px]" (ngModelChange)="onUpdateSessionDateChange($event)" [(ngModel)]="updateDate"
            nzFormat="dd/MM/YYYY"></nz-date-picker>
        </div>
      </div>
    </div>
    <div nz-row class="flex-col" nzAlign="middle">
      <h1 *ngIf="checkBoxTimeRangeOptions.length > 0">Available Slots</h1>
      <div *ngIf="checkBoxTimeRangeOptions.length <= 0">No Available Slots</div>
      <nz-checkbox-wrapper>
        <div *ngFor="let status of checkBoxTimeRangeOptions" nz-row>
          <div nz-col>
            <label nz-checkbox [nzChecked]="status.checked" [nzDisabled]="
                (!status.value.notAvailableSlotExists &&
                  !status.value.available) ||
                status.disabled
              " (nzCheckedChange)="onCheckboxChange(status)">
              {{ status.label }}
              <span *ngIf="status.isOverlapUnavailable"
                style="color: #ff4d4f; margin-left: 8px; font-size: 12px; font-weight: 500;">(Overlap)</span>
              <span *ngIf="!status.value.available || status.value.notAvailableSlotExists"
                style="color: #8c8c8c; margin-left: 8px; font-size: 12px;">(Unavailable)</span>
            </label>
          </div>
        </div>
      </nz-checkbox-wrapper>
    </div>
  </ng-container>
</nz-modal>
<nz-dropdown-menu #partnerIdMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <!-- <div nz-col>
        <span class="font-bold">Partner Id</span>
        <nz-divider></nz-divider> -->
      <!-- <nz-checkbox-wrapper (nzOnChange)="partnerIdFilterChangeFn($event)">
          <div *ngFor="let partnerId of partnerIdCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                [ngModel]="partnerId.checked"
                [nzValue]="partnerId.value"
                nz-checkbox
                >{{ partnerId.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
      <div nz-col>
        <nz-divider class="height:14em" nzType="vertical"></nz-divider>
      </div> -->
      <div nz-col>
        <span class="font-bold">Partner Name</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="partnerIdFilterChangeFn($event)">
          <div *ngFor="let state of partnerCompanyNameCheckBoxOptions" nz-row>
            <div nz-col>
              <label nz-checkbox [nzValue]="state.value" [ngModel]="state.checked">{{ state.label }}</label>
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="this.reloadTableEvent.emit()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<nz-dropdown-menu #sessionTagMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Session Tags</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="sessionTagFilterChangeFn($event)">
          <div *ngFor="let state of sessionTagFilterOption" nz-row>
            <div nz-col>
              <label nz-checkbox [nzValue]="state.value" [ngModel]="state.checked">{{ state.label }}</label>
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="this.reloadTableEvent.emit()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<!-- <nz-modal
  [nzOkLoading]="activateNewPlanLoading"
  [(nzVisible)]="activateNewPlanModal"
  nzTitle="Activate new Plan"
  (nzOnCancel)="hideActivateNewPlanModal()"
  (nzOnOk)="activateNewPlan()"
  nzOkText="Activate Plan"
>
  <ng-container *nzModalContent>
    <div nz-row>
      <div nz-row nzAlign="middle"></div>
      <div nz-col colspan="2">
        <div>
          <input
            class="w-[300px]"
            placeholder="Search Users"
            nz-input
            [(ngModel)]="selectedUser"
            (input)="onSearchUser($event)"
            [nzAutocomplete]="auto"
            (ngModelChange)="onUserSelectFn($event)"
          />
          <nz-autocomplete
            [nzDataSource]="userSearchResults"
            nzBackfill
            #auto
          ></nz-autocomplete>
        </div>
      </div>
      <div nz-col colspan="1" class="ml-5">
        <nz-spin
          nzSimple
          [nzSpinning]="searchSpinner"
          [nzSize]="'small'"
        ></nz-spin>
      </div>
    </div>
    <div nz-row nzAlign="middle" class="mt-2">
      <div nz-col colspan="2">
        <nz-select
          class="w-[300px]"
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select Therapist"
          [(ngModel)]="selectedTherapist"
          (ngModelChange)="therapistSelectedFn($event)"
        >
          <nz-option
            *ngFor="let th of activeTherapists"
            [nzLabel]="th.email"
            [nzValue]="th._id"
          ></nz-option>
        </nz-select>
      </div>
    </div>
    <div nz-row nzAlign="middle" class="mt-2">
      <div nz-col colspan="2">
        <nz-select
          class="w-[300px]"
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select Vertical"
          [(ngModel)]="selectedVerticalId"
          (ngModelChange)="onVerticalChange($event)"
        >
          <nz-option
            *ngFor="let th of verticals"
            [nzLabel]="th.data"
            [nzValue]="th.m_id"
          ></nz-option>
        </nz-select>
      </div>
    </div>
    <div nz-row nzAlign="middle" class="mt-2"></div>
    <div nz-col colspan="2">
      <nz-select
        class="w-[300px]"
        nzShowSearch
        nzAllowClear
        [(ngModel)]="selectedConcernId"
        nzPlaceHolder="Select Concern"
        (ngModelChange)="onConcernChange($event)"
      >
        <nz-option
          *ngFor="let th of filteredConcerns"
          [nzLabel]="th.data"
          [nzValue]="th.m_id"
        ></nz-option>
      </nz-select>
    </div>
    <div nz-row nzAlign="middle" class="mt-2">
      <div nz-col colspan="2">
        <nz-select
          class="w-[300px]"
          nzShowSearch
          nzAllowClear
          [(ngModel)]="selectedPlanId"
          nzPlaceHolder="Select Plan"
          (ngModelChange)="onPlanChange($event)"
        >
          <nz-option
            *ngFor="let th of plansForSelectedConcern"
            [nzLabel]="th.planName"
            [nzValue]="th.planId"
          ></nz-option>
        </nz-select>
      </div>
      <div nz-col colspan="1" class="ml-5">
        <nz-spin
          nzSimple
          [nzSpinning]="fetchPlansLoading"
          [nzSize]="'small'"
        ></nz-spin>
      </div>
    </div>
    <div nz-row nzAlign="middle" class="mt-2">
      <input
        nz-input
        placeholder="Enter Payment Order Id"
        [(ngModel)]="paymentOrderId"
      />
      Type FREE_ACTIVATION to activate plan for free
    </div>
  </ng-container>
</nz-modal> -->
<nz-modal [nzOkLoading]="addRemarkForPastUserLoading" [(nzVisible)]="showRemarkForm" nzTitle="Admin Remarks"
  (nzOnCancel)="closeRemarkForm()" (nzOnOk)="addRemarkForPastUser()">
  <ng-container *nzModalContent>
    <div nz-row>
      <textarea rows="4" nz-input placeholder="Remarks" class="placeholder:opacity-100"
        [(ngModel)]="remarkForPastSession"></textarea>
    </div>
  </ng-container>
</nz-modal>
<nz-drawer [nzClosable]="true" [nzVisible]="activateNewPlanModal" [nzPlacement]="'bottom'" nzTitle="Activate new Plan"
  (nzOnClose)="close()">
  <ng-container *nzDrawerContent>
    <div nz-row>
      <div nz-row nzAlign="middle"></div>
      <div nz-col colspan="2">
        <div>
          <input class="w-[300px]" placeholder="Search Users" nz-input [(ngModel)]="selectedUser"
            (input)="onSearchUser($event)" [nzAutocomplete]="auto" (ngModelChange)="onUserSelectFn($event)" />
          <nz-autocomplete [nzDataSource]="userSearchResults" nzBackfill #auto></nz-autocomplete>
        </div>
      </div>
      <div nz-col colspan="1" class="ml-5">
        <nz-spin nzSimple [nzSpinning]="searchSpinner" [nzSize]="'small'"></nz-spin>
      </div>
    </div>
    <div nz-row nzAlign="middle" class="mt-2">
      <div nz-col colspan="2">
        <nz-select class="w-[300px]" nzShowSearch nzAllowClear nzPlaceHolder="Select Vertical"
          [(ngModel)]="selectedVerticalId" (ngModelChange)="onVerticalChange($event)">
          <nz-option *ngFor="let th of verticals" [nzLabel]="th.data" [nzValue]="th.m_id"></nz-option>
        </nz-select>
      </div>
    </div>
    <div nz-row nzAlign="middle" class="mt-2"></div>
    <div nz-col colspan="2">
      <nz-select class="w-[300px]" nzShowSearch nzAllowClear [(ngModel)]="selectedConcernId"
        nzPlaceHolder="Select Concern" (ngModelChange)="onConcernChange($event)">
        <nz-option *ngFor="let th of filteredConcerns" [nzLabel]="th.data" [nzValue]="th.m_id"></nz-option>
      </nz-select>
    </div>
    <div nz-row nzAlign="middle" class="mt-2">
      <div nz-col colspan="2">
        <nz-select class="w-[300px]" nzShowSearch nzAllowClear nzPlaceHolder="Select Therapist"
          [(ngModel)]="selectedTherapist" (ngModelChange)="therapistSelectedFn($event)">
          <nz-option *ngFor="let th of therapistByVerticalConcern" [nzLabel]="th.name" [nzValue]="th.id"></nz-option>
        </nz-select>
      </div>
    </div>
    <div nz-row nzAlign="middle" class="mt-2">
      <div nz-col colspan="2">
        <nz-select class="w-[300px]" nzShowSearch nzAllowClear [(ngModel)]="selectedPlanId" nzPlaceHolder="Select Plan"
          (ngModelChange)="onPlanChange($event)">
          <nz-option *ngFor="let th of plansForSelectedConcern" [nzLabel]="
              th.planName +
              ' - ' +
              th.charges?.currencySymbol +
              ' ' +
              th.charges?.amount
            " [nzValue]="th.planId"></nz-option>
        </nz-select>
      </div>
      <div nz-col colspan="1" class="ml-5">
        <nz-spin nzSimple [nzSpinning]="fetchPlansLoading" [nzSize]="'small'"></nz-spin>
      </div>
    </div>
    <div nz-row nzAlign="middle" class="mt-2">
      <input nz-input placeholder="Enter Payment Order Id" [(ngModel)]="paymentOrderId" />
      Type FREE_ACTIVATION to activate plan for free
    </div>
    <div>
      <button nz-button nzType="primary" (click)="activateNewPlan()">
        Activate Plan
      </button>
    </div>
  </ng-container>
</nz-drawer>
<nz-drawer [nzClosable]="true" [nzVisible]="visibleMeetParticipant" [nzPlacement]="'bottom'" nzTitle="Meet Participants"
  (nzOnClose)="closeMeetParticipant()">
  <ng-container *nzDrawerContent>
    <nz-table #basicTable nzFrontPagination="true" [nzPageSize]="5" [nzData]="dataMeetParticipant">
      <thead>
        <tr>
          <th>Display Name</th>
          <th>Duration</th>
          <th>Indentifier</th>
          <th>Client</th>
          <th>Expert</th>
          <th>External</th>
          <th>Session Count</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <td>{{ data.displayName }}</td>
          <td>{{ data.durationFormatted }}</td>
          <td>
            {{ data.identifier }}
          </td>
          <td>
            {{ data.isClient ? "yes" : "no" }}
          </td>
          <td>
            {{ data.isExpert ? "yes" : "no" }}
          </td>
          <td>
            {{ data.isExternal ? "yes" : "no" }}
          </td>
          <td>
            {{ data.sessionCount }}
          </td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>
</nz-drawer>

<nz-modal [(nzVisible)]="isAddRewardModalVisible" [nzFooter]="null" (nzOnCancel)="closeAddRewardModal()"
  nzTitle="Add Reward">
  <nz-spin [nzSpinning]="isAddRewardLoading" nzSize="large" nzTip="Submitting...">
    <ng-container *nzModalContent>
      <form [formGroup]="addRewardForm" (ngSubmit)="submitAddRewardForm()" class="flex flex-col space-y-3">
        <nz-form-item>
          <nz-form-label [nzSpan]="6">Amount</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <input nz-input formControlName="amount" type="number" placeholder="Enter amount" class="input-field" />
            <div *ngIf="
                addRewardForm.controls['amount'].invalid &&
                addRewardForm.controls['amount'].touched
              " class="error-text">
              Amount is required.
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">Transaction Direction</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-select formControlName="transactionDirection" placeholder="Select direction" class="w-full input-field">
              <nz-option nzValue="Debit" nzLabel="Debit (-)"></nz-option>
              <nz-option nzValue="Credit" nzLabel="Credit (+)"></nz-option>
            </nz-select>
            <div *ngIf="
                addRewardForm.controls['transactionDirection'].invalid &&
                addRewardForm.controls['transactionDirection'].touched
              " class="error-text">
              Transaction direction is required.
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">Description</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <textarea nz-input formControlName="description" rows="3" placeholder="Enter description"
              class="input-field"></textarea>
            <div *ngIf="
                addRewardForm.controls['description'].invalid &&
                addRewardForm.controls['description'].touched
              " class="error-text">
              Description is required.
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="flex flex-row justify-end gap-3">
          <nz-form-control>
            <button [disabled]="addRewardForm.invalid || isAddRewardLoading" nz-button nzType="primary" type="submit"
              class="submit-button ml-3">
              {{ isAddRewardLoading ? "Submitting..." : "Submit" }}
            </button>
            <button [disabled]="isAddRewardLoading" (click)="closeAddRewardModal()" nz-button nzType="default"
              type="button">
              Cancel
            </button>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-spin>
</nz-modal>

<!-- Override Session Status Modal -->
<nz-modal [(nzVisible)]="showOverrideModal" [nzFooter]="null" (nzOnCancel)="closeOverrideModal()"
  nzTitle="Override Session Status" nzWidth="600px">
  <nz-spin [nzSpinning]="overrideSubmitLoading" nzSize="large" nzTip="Submitting...">
    <ng-container *nzModalContent>
      <div *ngIf="overrideModalSession" class="p-2">
        <div class="mb-4 text-sm text-gray-600">
          <strong>Session:</strong>
          {{ overrideModalSession.clientDetails.name }} /
          {{ overrideModalSession.therapistDetails.therapistName }}<br />
          <strong>Current Status:</strong>
          {{ overrideModalSession.sessionStatus }}
        </div>

        <div class="mb-4">
          <label class="block font-semibold mb-1">Target Status <span class="text-red-500">*</span></label>
          <nz-select [(ngModel)]="overrideTargetStatus" (ngModelChange)="onOverrideTargetStatusChange()"
            nzPlaceHolder="Select target status" class="w-full">
            <nz-option *ngFor="let status of getOverrideTargetStatuses()" [nzValue]="status"
              [nzLabel]="status"></nz-option>
          </nz-select>
        </div>

        <div class="mb-4">
          <label class="block font-semibold mb-1">Reason <span class="text-red-500">*</span></label>
          <textarea nz-input [(ngModel)]="overrideReason" rows="3"
            placeholder="Explain why the status is being overridden" class="w-full"></textarea>
        </div>

        <div class="mb-4" *ngIf="overrideTargetStatus">
          <label class="block font-semibold mb-2">Side Effects (opt-in)</label>
          <div class="flex flex-col gap-2">
            <label nz-checkbox [(ngModel)]="overrideSideEffects.meetCancel" *ngIf="showSideEffect('meetCancel')">
              Cancel Google Meet invite
            </label>
            <label nz-checkbox [(ngModel)]="overrideSideEffects.notifDelete" *ngIf="showSideEffect('notifDelete')">
              Delete all scheduled notifications for this session
            </label>
            <span class="text-gray-400 text-xs" *ngIf="
                !showSideEffect('meetCancel') && !showSideEffect('notifDelete')
              ">
              No side effects applicable for this transition.
            </span>
          </div>
        </div>

        <div class="flex justify-end gap-3 mt-4">
          <button nz-button nzType="primary" [nzDanger]="true" (click)="submitOverride()" [disabled]="
              !overrideTargetStatus ||
              !overrideReason.trim() ||
              overrideSubmitLoading
            ">
            {{ overrideSubmitLoading ? "Submitting..." : "Override Status" }}
          </button>
          <button nz-button nzType="default" (click)="closeOverrideModal()" [disabled]="overrideSubmitLoading">
            Cancel
          </button>
        </div>
      </div>
    </ng-container>
  </nz-spin>

  <!-- ── Policy Trace Drawer ─────────────────────────────────────── -->
  <nz-drawer [nzVisible]="policyTraceDrawerVisible" nzPlacement="right" nzWidth="640px" nzTitle="Policy Trace"
    (nzOnClose)="closePolicyTrace()">
    <ng-container *nzDrawerContent>
      <ng-container *ngIf="selectedPolicyTrace">
        <p class="text-xs text-gray-400 -mt-3 mb-4">
          {{ selectedPolicyTraceSessionLabel }}
        </p>

        <!-- Verdict -->
        <nz-alert class="mb-4" [nzType]="policySessionAllowed() ? 'success' : 'error'" [nzMessage]="
          policySessionAllowed() ? 'Session Allowed' : 'Session Blocked'
        " [nzDescription]="
          !policySessionAllowed() && selectedPolicyTrace.outputs.blockReason
            ? 'Reason: ' + selectedPolicyTrace.outputs.blockReason
            : ''
        " nzShowIcon></nz-alert>

        <!-- Outputs -->
        <p class="font-semibold text-xs uppercase tracking-wider text-gray-500 mb-2">Outputs</p>
        <nz-descriptions nzBordered nzSize="small" [nzColumn]="2" class="mb-4">
          <nz-descriptions-item nzTitle="Session Allowed">
            <nz-tag [nzColor]="policySessionAllowed() ? 'green' : 'red'">
              {{ selectedPolicyTrace.outputs.sessionAllowed }}
            </nz-tag>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Payer">
            <nz-tag nzColor="blue" *ngIf="selectedPolicyTrace.outputs.payer">
              {{ selectedPolicyTrace.outputs.payer }}
            </nz-tag>
            <span *ngIf="!selectedPolicyTrace.outputs.payer">—</span>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Session Minutes">
            {{ selectedPolicyTrace.outputs.sessionMinutes || '—' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Cooldown">
            {{ selectedPolicyTrace.outputs.cooldown || '—' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Block Reason" [nzSpan]="2">
            <span class="text-red-500" *ngIf="selectedPolicyTrace.outputs.blockReason">
              {{ selectedPolicyTrace.outputs.blockReason }}
            </span>
            <span *ngIf="!selectedPolicyTrace.outputs.blockReason">—</span>
          </nz-descriptions-item>
        </nz-descriptions>

        <!-- Evaluation Context -->
        <p class="font-semibold text-xs uppercase tracking-wider text-gray-500 mb-2">Evaluation Context</p>
        <nz-descriptions nzBordered nzSize="small" [nzColumn]="2" class="mb-4">
          <nz-descriptions-item nzTitle="Evaluated At">
            {{ selectedPolicyTrace.evaluatedAt | date : 'dd MMM yyyy, HH:mm:ss' : 'UTC' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Company ID">
            <span class="font-mono text-xs">{{ selectedPolicyTrace.companyId }}</span>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Vertical">
            {{ selectedPolicyTrace.verticalName || selectedPolicyTrace.verticalId }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Concern">
            {{ selectedPolicyTrace.concernName || selectedPolicyTrace.concernId }}
          </nz-descriptions-item>
        </nz-descriptions>

        <!-- Winners by Field -->
        <p class="font-semibold text-xs uppercase tracking-wider text-gray-500 mb-2">
          Winners by Field
          <span class="normal-case font-normal text-gray-400">(which rule decided each output)</span>
        </p>
        <nz-table nzSize="small" [nzData]="winnerEntries()" [nzShowPagination]="false" class="mb-4">
          <thead>
            <tr>
              <th>Field</th>
              <th>Winning Rule</th>
              <th>Priority</th>
              <th>Scope</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of winnerEntries()">
              <td><strong>{{ entry[0] }}</strong></td>
              <td>
                <span *ngIf="entry[1]">{{ entry[1].ruleName }}</span>
                <span *ngIf="!entry[1]" class="text-gray-400">—</span>
              </td>
              <td>{{ entry[1]?.priority ?? '—' }}</td>
              <td>
                <nz-tag *ngIf="entry[1]" [nzColor]="entry[1].isGlobal ? 'default' : 'purple'">
                  {{ entry[1].isGlobal ? 'Global' : 'Company' }}
                </nz-tag>
              </td>
            </tr>
          </tbody>
        </nz-table>

        <!-- Facts -->
        <p class="font-semibold text-xs uppercase tracking-wider text-gray-500 mb-2">Facts at Evaluation Time</p>
        <nz-table nzSize="small" [nzData]="objectEntries(selectedPolicyTrace.facts)" [nzShowPagination]="false">
          <thead>
            <tr>
              <th>Fact</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of objectEntries(selectedPolicyTrace.facts)">
              <td>{{ entry[0] }}</td>
              <td>
                <strong *ngIf="entry[0] === 'sessionsConsumedInPeriod' || entry[0] === 'totalSessionsConsumedInPeriod'">
                  {{ entry[1] }}
                </strong>
                <span *ngIf="entry[0] !== 'sessionsConsumedInPeriod' && entry[0] !== 'totalSessionsConsumedInPeriod'">
                  {{ entry[1] }}
                </span>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </ng-container>
    </ng-container>
  </nz-drawer>
</nz-modal>